import { render } from "./DocumentsView.vue?vue&type=template&id=672dcd8c&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"

import "./DocumentsView.vue?vue&type=style&index=0&id=672dcd8c&scoped=true&lang=css"
import "./DocumentsView.vue?vue&type=style&index=1&id=672dcd8c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672dcd8c"]])

export default __exports__